import React, { useEffect, useState } from 'react';
import {
  Box, CssBaseline, Typography, Avatar, IconButton, Stack, Button, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem,
  Select, FormControl, InputLabel, TextField, InputAdornment, Grid,
  Tooltip, CircularProgress, Snackbar, Alert, Breadcrumbs, Link, Backdrop
} from '@mui/material';
import {
  School, Search, ArrowBack, ReceiptLong, FilterList, Download
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ExamDocument from './ExamDocument';
import moment from 'moment';

const colors = {
  pageBg: '#F8F9FA',
  sidebarBg: '#F1F2F6',
  filterBg: "#FFF9E6",
  accent: '#FFC107',
  tableHeader: '#FDF7E2',
  textMain: '#5D4037',
  examBottom: '#FFEBEE',
  examMiddle: '#FFF9C4',
  examTop: '#E8F5E9',
};

const columns = [
  { id: 'Student_Name', name: 'Nama' },
  { id: 'K1_Bahasa_Melayu', name: 'K1 B. Melayu' }, { id: 'K1_Bahasa_Inggeris', name: 'K1 English' }, { id: 'K1_Matematik', name: 'K1 Matematik' }, { id: 'K1_Sains', name: 'K1 Sains' },
  { id: 'K2_Bahasa_Melayu', name: 'K2 B. Melayu' }, { id: 'K2_Bahasa_Inggeris', name: 'K2 English' }, { id: 'K2_Matematik', name: 'K2 Matematik' }, { id: 'K2_Sains', name: 'K2 Sains' },
  { id: 'K3_Bahasa_Melayu', name: 'K3 B. Melayu' }, { id: 'K3_Bahasa_Inggeris', name: 'K3 English' }, { id: 'K3_Matematik', name: 'K3 Matematik' }, { id: 'K3_Sains', name: 'K3 Sains' },
  { id: 'K4_Bahasa_Melayu', name: 'K4 B. Melayu' }, { id: 'K4_Bahasa_Inggeris', name: 'K4 English' }, { id: 'K4_Matematik', name: 'K4 Matematik' }, { id: 'K4_Sains', name: 'K4 Sains' },
  { id: 'K5_Bahasa_Melayu', name: 'K5 B. Melayu' }, { id: 'K5_Bahasa_Inggeris', name: 'K5 English' }, { id: 'K5_Matematik', name: 'K5 Matematik' }, { id: 'K5_Sains', name: 'K5 Sains' },
  { id: 'K6_Bahasa_Melayu', name: 'E1 B. Melayu' }, { id: 'K6_Bahasa_Inggeris', name: 'E1 English' }, { id: 'K6_Matematik', name: 'E1 Matematik' }, { id: 'K6_Sains', name: 'E1 Sains' },
  { id: 'K7_Bahasa_Melayu', name: 'K7 B. Melayu' }, { id: 'K7_Bahasa_Inggeris', name: 'K7 English' }, { id: 'K7_Matematik', name: 'K7 Matematik' }, { id: 'K7_Sains', name: 'K7 Sains' },
  { id: 'K8_Bahasa_Melayu', name: 'K8 B. Melayu' }, { id: 'K8_Bahasa_Inggeris', name: 'K8 English' }, { id: 'K8_Matematik', name: 'K8 Matematik' }, { id: 'K8_Sains', name: 'K8 Sains' },
  { id: 'K9_Bahasa_Melayu', name: 'K9 B. Melayu' }, { id: 'K9_Bahasa_Inggeris', name: 'K9 English' }, { id: 'K9_Matematik', name: 'K9 Matematik' }, { id: 'K9_Sains', name: 'K9 Sains' },
  { id: 'K10_Bahasa_Melayu', name: 'K10 B. Melayu' }, { id: 'K10_Bahasa_Inggeris', name: 'K10 English' }, { id: 'K10_Matematik', name: 'K10 Matematik' }, { id: 'K10_Sains', name: 'K10 Sains' },
  { id: 'K11_Bahasa_Melayu', name: 'K11 B. Melayu' }, { id: 'K11_Bahasa_Inggeris', name: 'K11 English' }, { id: 'K11_Matematik', name: 'K11 Matematik' }, { id: 'K11_Sains', name: 'K11 Sains' },
  { id: 'K12_Bahasa_Melayu', name: 'E2 B. Melayu' }, { id: 'K12_Bahasa_Inggeris', name: 'E2 English' }, { id: 'K12_Matematik', name: 'E2 Matematik' }, { id: 'K12_Sains', name: 'E2 Sains' }
];

const classList = [
  { id: "D1", title: "Darjah 1" }, { id: "D2", title: "Darjah 2" }, { id: "D3", title: "Darjah 3" },
  { id: "D4", title: "Darjah 4" }, { id: "D5", title: "Darjah 5" }, { id: "D6", title: "Darjah 6" },
  { id: "F1", title: "Tingkatan 1" }, { id: "F2", title: "Tingkatan 2" }, { id: "F3", title: "Tingkatan 3" },
  { id: "F4", title: "Tingkatan 4" }, { id: "F5", title: "Tingkatan 5" }
];

export default function ExamPreview() {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classroom, setClassroom] = useState('NA');
  const [year, setYear] = useState(moment().format("YYYY"));
  const [studentData, setStudentData] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  const month = "NA";

  const yearList = Array.from({ length: 5 }, (_, i) => (moment().year() - i).toString());

  const getStudentData = async () => {
    if (classroom === 'NA') return;
    setLoading(true);
    try {
      const response = await fetch(`https://www.geniusmileniaeducation.link/api/getStudentAllExam/${classroom}(${year})`);
      const json = await response.json();
      setStudentData(json.data || []);
      setFiltered(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getCellStyles = (val) => {
    if (!val || val === "") return {};
    const n = parseInt(val);
    if (isNaN(n)) return { bgcolor: '#F5F5F5' };
    if (n < 40) return { bgcolor: colors.examBottom, color: '#C62828' };
    const threshold = (classroom.startsWith('F4') || classroom.startsWith('F5')) ? 70 : 80;
    return n < threshold ? { bgcolor: colors.examMiddle, color: '#827717' } : { bgcolor: colors.examTop, color: '#2E7D32' };
  };

  return (
    <Box sx={{ display: 'flex', bgcolor: colors.sidebarBg, minHeight: '100vh' }}>
      <CssBaseline />

      <Backdrop sx={{ color: colors.accent, zIndex: (theme) => theme.zIndex.drawer + 10 }} open={loading}>
        <Stack alignItems="center" spacing={2}>
          <CircularProgress color="inherit" />
          <Typography variant="h6" color="white">Preparing Slips...</Typography>
        </Stack>
      </Backdrop>

      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: "white", m: 2, borderRadius: 5 }}>

        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={4}>
          <Box>
            <Breadcrumbs sx={{ mb: 1 }}>
              <Link underline="hover" color="inherit" onClick={() => navigate("/Portal")} sx={{ cursor: 'pointer' }}>Portal</Link>
              <Typography color="text.primary">Academic</Typography>
            </Breadcrumbs>
            <Typography variant="h4" fontWeight="bold" color={colors.textMain}>{filtered ? `${classroom} Slips (${year})` : 'Exam Slip Generation'}</Typography>
          </Box>
          {filtered && (
            <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => { setFiltered(false); setStudentData([]); }} sx={{ borderRadius: 2 }}>
              Change Session
            </Button>
          )}
        </Stack>

        {!filtered ? (
          <Paper elevation={0} sx={{ p: 4, bgcolor: colors.filterBg, borderRadius: 4, textAlign: 'center', border: '1px solid #F0E6CC' }}>
            <School sx={{ fontSize: 60, color: colors.accent, mb: 2 }} />
            <Typography variant="h5" fontWeight="bold" mb={3} color={colors.textMain}>Select Class and Year to Proceed</Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Class</InputLabel>
                  <Select value={classroom} label="Class" onChange={(e) => setClassroom(e.target.value)} sx={{ bgcolor: 'white' }}>
                    <MenuItem value="NA">None</MenuItem>
                    {classList.map(c => <MenuItem key={c.id} value={c.id}>{c.title}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Year</InputLabel>
                  <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)} sx={{ bgcolor: 'white' }}>
                    {yearList.map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Button variant="contained" onClick={getStudentData} sx={{ mt: 4, bgcolor: colors.accent, color: 'black', fontWeight: 'bold', px: 6, py: 1.5, borderRadius: 3 }}>
              Generate Slip Grid
            </Button>
          </Paper>
        ) : (
          <>
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: colors.filterBg, borderRadius: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
              <FilterList sx={{ color: colors.textMain }} />
              <TextField size="small" placeholder="Search Student..." fullWidth onChange={(e) => setFilterSearch(e.target.value.toUpperCase())} sx={{ bgcolor: 'white', borderRadius: 2 }}
                InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> }} />

              <PDFDownloadLink
                document={<ExamDocument data={studentData} classroom={classroom} month={month} year={year} />}
                fileName={`${classroom}_${year}_Slips.pdf`}
                style={{ textDecoration: 'none' }}
              >
                {({ loading }) => (
                  <Button variant="contained" startIcon={loading ? <CircularProgress size={16} /> : <ReceiptLong />}
                    sx={{ bgcolor: 'black', color: 'white', borderRadius: 2, minWidth: 160, '&:hover': { bgcolor: '#333' } }}>
                    {loading ? 'Processing...' : 'Download All Slips'}
                  </Button>
                )}
              </PDFDownloadLink>
            </Paper>

            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #F0E6CC', borderRadius: 4, maxHeight: 600 }}>
              <Table stickyHeader sx={{ borderCollapse: 'separate' }}>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell
                        key={col.id}
                        sx={{
                          bgcolor: col.id === 'Student_Name' ? colors.accent : colors.tableHeader,
                          fontWeight: 'bold',
                          zIndex: col.id === 'Student_Name' ? 11 : 10,
                          left: col.id === 'Student_Name' ? 0 : 'auto',
                          position: col.id === 'Student_Name' ? 'sticky' : 'static',
                          borderRight: col.id === 'Student_Name' ? '2px solid #E0D6B7' : '1px solid #EEE'
                        }}
                      >
                        {col.name}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {studentData.filter(s => s.Student_Name?.includes(filterSearch)).map((s, i) => (
                    <TableRow key={i} hover>
                      {columns.map((col) => {
                        const isName = col.id === 'Student_Name';
                        const val = s[col.id] || "";
                        const cellStyle = !isName ? getCellStyles(val) : {};

                        return (
                          <TableCell
                            key={col.id}
                            sx={{
                              ...cellStyle,
                              position: isName ? 'sticky' : 'static',
                              left: isName ? 0 : 'auto',
                              bgcolor: isName ? 'white' : cellStyle.bgcolor || 'inherit',
                              zIndex: isName ? 5 : 1,
                              borderRight: isName ? '2px solid #F0E6CC' : '1px solid #FFF',
                              fontWeight: isName ? 'bold' : 'medium',
                              textAlign: isName ? 'left' : 'center'
                            }}
                          >
                            {isName ? (
                              <Stack direction="row" spacing={1.5} alignItems="center">
                                <Avatar sx={{ bgcolor: '#FFECB3', color: '#FF8F00', fontSize: 11, width: 28, height: 28 }}>{s.Student_Name?.substring(0, 2)}</Avatar>
                                <Typography variant="caption" fontWeight="bold">{s.Student_Name}</Typography>
                              </Stack>
                            ) : val}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </Box>
    </Box>
  );
}